import { gql } from "@apollo/client";

export const FRAGMENT_MEMBER_LIST_PARTS = gql`
  fragment MembersListParts on Members {
    id
    member
    firstName
    lastName
    email
    timezone
    status
    statusDate
    action {
      buttonAction
      buttonText
      buttonStyle
    }
  }
`;

export const FRAGMENT_INTEGRATIONS_SCREEN_PARTS = gql`
  fragment IntegrationsScreenParts on IntegrationsScreen {
    title
    subTitle
    domains {
      title
      subTitle
      labels
      addButton {
        buttonAction
        buttonText
        buttonStyle
      }
      domainList {
        name
        dateAdded
        action {
          buttonAction
          buttonText
          buttonStyle
        }
      }
    }
    sso {
      title
      subTitle
      signIn {
        title
        items {
          id
          name
          isEnabled
        }
      }
      signUp {
        title
        isEnabled
      }
    }
    hris {
      title
      subTitle
      connections {
        id
        logo
        name
        subCompanyName
      }
      link
    }
  }
`;

export const FRAGMENT_DASHBOARD_INFO_PARTS = gql`
  fragment dashboardInfoParts on DashboardScreen {
    token
    views
  }
`;
